import { ChipSetService } from './ChipSetService'

export const chipSetService = new ChipSetService()
